export default __webpack_public_path__ + "static/media/ikenna.8709171b.jpg";